import { Provider } from 'react-redux';
import { StyleCacheProvider } from 'shared/components';

import { initI18n } from 'configs/i18n';
import { setupStore } from 'redux/store';
import { AppRouter } from 'routers/AppRouter';
import('styles/styles.scss');

initI18n();

const store = setupStore();

export const App = () => (
  <Provider store={store}>
    <StyleCacheProvider appName="yki">
      <AppRouter />
    </StyleCacheProvider>
  </Provider>
);
